'use client'
import type { OrganizationStatusEnum } from '@carbonara/postgres/src/schema'
import { ClockFading } from 'lucide-react'
import { CheckCheck as Checkmarks } from 'lucide-react'
import Link from 'next/link'
import { DropdownMenuItem, DropdownMenuLabel } from '../../ui/dropdown-menu'
import { registerLastSwitchedToOrganization } from './actions'

interface Props {
	active: boolean
	name: string
	id: string
	status: OrganizationStatusEnum
}

export const OrganizationItem: React.FC<Props> = ({
	active,
	name,
	id,
	status,
}) => {
	if (active) {
		return (
			<DropdownMenuLabel className="flex flex-row justify-between">
				<div className="overflow-hidden text-ellipsis whitespace-nowrap">
					{name}
				</div>
				<Checkmarks className="ml-4 size-4" />
			</DropdownMenuLabel>
		)
	}
	return (
		<Link
			href={`/org/${id}`}
			onClick={() => registerLastSwitchedToOrganization(id)}
		>
			<DropdownMenuItem className="overflow-hidden text-ellipsis whitespace-nowrap">
				{name}
				{status !== 'activated' && <ClockFading className="ml-2 size-3" />}
			</DropdownMenuItem>
		</Link>
	)
}
